// v-calendar disables auto-hide for click-visibility popovers and stops the
// opening click from propagating, so a second picker opens on top of the
// first. Registered pickers dismiss all the others when their input is clicked.
const pickers = new Set()

export const registerPicker = picker => {
  pickers.add(picker)
}

export const unregisterPicker = picker => {
  pickers.delete(picker)
}

export const soloPicker = current => {
  pickers.forEach(picker => {
    if (picker !== current) picker.hidePopover()
  })
}
